import React, {
  ChangeEvent,
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  StyledCheckoutDrawer,
  StyledDrawerBody,
  StyledDrawerHeader,
  StyledEstimatedDeliveryDate,
  StyledEstimatedDeliveryText,
  StyledClinButton,
  StyledSpinnerContainer,
  StyledNewCheckoutBlock,
  StyledNewCheckoutBlockHeader,
  StyledButtonSection,
  StyledCheckoutDeliveryDateContainer,
  StyledCheckoutDeliveryDateContent,
  StyledCheckoutDeliveryDateIconContainer,
  StyledCheckoutPoBlock,
  StyledCheckoutTextareaContainer,
  StyledDeclarationCheckoutBlockBody,
  StyledNewCheckoutAdditionalBlock,
  StyledNewCheckoutBlockBody,
  StyledNewCheckoutUserInfoBlock,
  StyledTableContainer,
  StyledDeliveryAddressWrap,
  StyledSummaryOneStepCheckout,
  StyledRow,
  StyledIcon,
  StyledClinButtonEdit,
  StyledClinButtonPrimary,
  StyledDeliveryAddressCheckoutWrapper,
  StyledButtonSection2,
  StyledAnnounceBarContainer,
  StyledClinButtonLink,
  StyledSafetyCheckoutBlockBody
} from './CheckoutDrawer.styles'
import { ClinText } from '../../components/ClinText'
import { ClinGroup } from '../../components/ClinGroup'
import { ClinTheme } from '../../ClinTheme'
import { ClinSpinner } from '../../components/ClinSpinner'
import { ClinIcon } from '../../components/ClinIcon'
import { ClinIconPathName } from '../../components/ClinIcon/ClinIcon.paths'
import { ClinSpacer } from '../../components/ClinSpacer'
import { ClinButton } from '../../components/ClinButton'
import { StyledColumn } from '../../pages/Checkout/Checkout.styles'
import { DeliveryAddress } from '../../pages/CheckoutOptions/DeliveryAddress'
import { ClinTextInput } from '../../components/ClinTextInput'
import { Col, Row } from 'react-grid-system'
import {
  StyledClinRadio,
  StyledDeliveryAddressNewCheckout,
  StyledNewShippingAddressLinkOneStepCheckout
} from '../../pages/CheckoutOptions/CheckoutOptions.styles'
import { TypographyVariant } from '../../components/ClinText/ClinText.styles'
import { ClinCheckbox } from '../../components/ClinCheckbox'
import { ClinTextarea } from '../../components/ClinTextarea'
import { DateTime } from 'luxon'
import i18n from '../../i18n/config'
import {
  StyledSummaryItemWrap,
  StyledSummaryTitle
} from '../../pages/Basket/Basket.styles'
import {
  QuantityCell,
  SkuCell,
  SubtotalCell,
  TableHeader
} from '../../pages/OpaCheckout/OpaCheckoutSteps/OrderDetails/OrderDetails.styles'
import { TableRow } from '@mui/material'
import { numberToCurrencyString } from '../../utils/numberToCurrencyString'
import { getBrowserLocale } from '../../utils/getBrowserLocale'
import {
  CreateCdhShippingAddressDto,
  CreateShippingAddressDto,
  ItemDocumentDto,
  OrderAddressDto,
  OrderDto,
  OrderLineDto,
  UpdateBasketDetailsDto
} from '../../types/swaggerTypes'
import { useAppContext } from '../../context/app'
import {
  AuthError,
  cancelDraftOrder,
  downloadDocumentById,
  getCurrentBasket,
  newUnvalidatedShippingAddress,
  placeDraftOrder,
  submitOrder,
  updateOrder
} from '../../services/ApiService'
import {
  ActionType,
  BasketStatus,
  getBasketAsync,
  useBasket
} from '../../context/basket'
import { getCountryIsoFromCode } from '../../utils/getCountryIsoFromCode'
import { defaultBasketDetails } from '../../constants'
import { getUserPhone } from '../../utils/getUserPhone'
import { createAnnounceEvent } from '../../events/AnnounceEvent'
import {
  AnnounceMode,
  ClinAnnounceBar
} from '../../components/ClinAnnounceBar/ClinAnnounceBar'
import analyticsServiceSingleton from '../../services/Analytics/initAnalytics'
import { AnalyticsEvent } from '../../services/Analytics'
import { AxiosError } from 'axios'
import useEmailValidation from '../../hooks/useCheckEmailError/useCheckEmailError'
import { useCountries } from '../../utils/useCountries'
import { getLocallyStoredInstituteId } from '../../services/UserInstituteService'
import {
  getInputValidation,
  ValidationType
} from '../../utils/Forms/getInputValidation'
import { debounce } from 'lodash'
import { returnDefaultBasketValues } from '../../pages/Basket/Basket'
import { showWootricSurvey } from '../../services/Wootric/showWootricSurvey'
import { handleBasketError } from '../../utils/basketUtils'
import EditIcon from '../../assets/media/icons/edit.svg'
import { useHistory } from 'react-router'
import { useFeatureFlags } from '../../context/featureFlags/FeatureFlagContext'
import { FeatureFlagKeys } from '../../context/featureFlags/FeatureFlagKeys'
import { ClinDrawer } from '../../components/ClinDrawer'
import { ShippingAddressDrawer } from '../ShippingAddressDrawer/ShippingAddressDrawer'
import { useAllHoldsInformation } from '../../services/Holds/holds'
import download from 'downloadjs'
import { getFilenameFromUrl } from '../../utils/getFilenameFromUrl'

interface ICheckoutDrawerProps {
  /** Handle closing the confirmation */
  handleClose?: () => void
}

export enum CheckoutViewMode {
  ShowOrders = 'ShowOrders',
  Submitting = 'Submitting',
  Loading = 'Loading',
  Redirect = 'Redirect'
}

interface FieldErrors {
  nameError?: string
  phoneError?: string
}

export const CheckoutDrawer: React.FC<ICheckoutDrawerProps> = (props) => {
  const { handleClose } = props
  const history = useHistory()
  const { t } = useTranslation()
  const { countries } = useCountries()
  const {
    dispatch,
    userDetails,
    defaultShippingAddress,
    portfolioCountryCode,
    institute,
    userRole,
    user
  } = useAppContext()
  const [
    { orders, viewBasket, basketDetails, completedOrder, basket },
    basketDispatch
  ] = useBasket()
  const { emailErrorMessage, checkEmail } = useEmailValidation()
  const [isEditing, setIsEditing] = React.useState(false)
  const [viewMode, setViewMode] = useState<CheckoutViewMode>(
    CheckoutViewMode.Loading
  )

  const [deliveryOptions, setDeliveryOptions] =
    useState<UpdateBasketDetailsDto>(basketDetails)

  const [deliveryAddresses, setDeliveryAddresses] = useState<OrderAddressDto[]>(
    []
  )
  const [fieldErrors, setFieldErrors] = useState<FieldErrors>({})
  const [isRefreshingBasket, setIsRefreshingBasket] = useState(false)
  const [isInitialLoad, setIsInitialLoad] = useState(true)
  const [draftOrderId, setDraftOrderId] = useState<string | undefined>(
    undefined
  )
  const [order, setOrder] = useState<OrderDto>()
  const [orderId, setOrderId] = useState<string | undefined>(undefined)
  const [allOrders, setAllOrders] = useState<OrderDto[]>([])
  const [isInitialized, setIsInitialized] = useState(false)
  const [deliveryNote, setDeliveryNote] = useState<string>('')
  const [showDeliveryNotes, setShowDeliveryNotes] = useState(false)
  const [isSubmittingAddress, setIsSubmittingAddress] = useState<boolean>(false)
  const [resetForm, setResetForm] = useState<boolean>(false)
  const [addressModalError, setAddressModalError] = useState<string>(
    'Error creating address'
  )
  const [isNewShippingAddressOpen, setIsNewShippingAddressOpen] =
    useState<boolean>(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [hasErrorMessage, setHasErrorMessage] = useState<string>()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState<
    string | undefined
  >(undefined)
  const [agreedTandCs, setAgreedTandCs] = useState<boolean>()
  const [orderWasSubmitted, setOrderWasSubmitted] = useState<boolean>(false)

  const [editForm, setEditForm] = useState({
    recipientName: deliveryOptions.deliverToContact || '',
    recipientEmail: deliveryOptions.recipientEmail || '',
    recipientPhone: deliveryOptions.recipientPhoneNumber || '',
    deliveryNote: deliveryNote || ''
  })

  const [isDuplicatePoModalOpen, setIsDuplicatePoModalOpen] =
    useState<boolean>(false)
  const [duplicatePoData, setDuplicatePoData] = useState<{
    poNumber: string
    orderNumbers: string[]
  } | null>(null)
  const [isProcessingDuplicatePo, setIsProcessingDuplicatePo] =
    useState<boolean>(false)
  const [poNumber, setPoNumber] = useState('')

  const [hasDownloadedSafetyLetter, setHasDownloadedSafetyLetter] =
    React.useState<boolean>(false)
  const holdInformation = useAllHoldsInformation([], viewBasket)

  const { useFeatureFlag } = useFeatureFlags()
  const isNewCheckoutPage = useFeatureFlag(
    FeatureFlagKeys.NewOneStepCheckoutPage
  )

  const localStorageDeliveryAddress = localStorage.getItem('deliveryAddress')
  const localStorageDeliveryAddressParsed = localStorageDeliveryAddress
    ? JSON.parse(localStorageDeliveryAddress)
    : null

  // Priority: 1. deliveryOptions.shippingAddressId, 2. localStorage, 3. defaultShippingAddress
  const selectedAddressId =
    deliveryOptions.shippingAddressId ||
    localStorageDeliveryAddressParsed?.shippingAddressId ||
    defaultShippingAddress?.addressId

  const isUK = portfolioCountryCode === 'GB'
  const isIE = portfolioCountryCode === 'IE'
  const summaryText = isUK
    ? 'basket:declaration.confirmation_text_uk'
    : 'basket:declaration.confirmation_text'

  const unlicensedMedicinalProductsGuidance =
    'https://assets.publishing.service.gov.uk/media/645e19f5ad8a03000c38b3bc/The_supply_of_unlicensed_medicinal_products__special_GN14.pdf'

  // Add a ref to track initialization status
  const initializationInProgress = useRef(false)

  // Refresh basket data
  const refreshBasketData = useCallback(async () => {
    try {
      setIsRefreshingBasket(true)
      const response = await getCurrentBasket()

      if (response?.data) {
        response.data.items ??= []
        response.data.orders ??= []

        basketDispatch({
          type: ActionType.UpdateBasket,
          basket: { data: response.data, isLoading: false }
        })
      }
    } catch (error) {
      dispatch(
        createAnnounceEvent(
          AnnounceMode.Error,
          `Error refreshing basket data: ${error}`
        )
      )
    } finally {
      setTimeout(() => {
        setIsRefreshingBasket(false)
        setIsInitialLoad(false)
      }, 100)
    }
  }, [basketDispatch, dispatch])

  const initOptions = async () => {
    await getCurrentBasket().then((response) => {
      if (response?.data.state === BasketStatus.CheckingOut.toString()) {
        cancelDraftOrder()
      }
    })

    const countryCode = getCountryIsoFromCode(
      defaultShippingAddress?.country || 'GB'
    )

    const defaultOptions: UpdateBasketDetailsDto = {
      ...defaultBasketDetails,
      shippingAddressId: defaultShippingAddress?.addressId,
      currencyCode: portfolioCountryCode || 'GBP',
      deliverToContact: userDetails?.contactCard?.name || '',
      recipientEmail: userDetails?.contactCard?.email || '',
      recipientPhoneNumber:
        getUserPhone(userDetails?.contactCard, countryCode) || '',
      poNumber: 'PO'
    }

    setDeliveryOptions(defaultOptions)

    await placeDraftOrder(
      defaultOptions.currencyCode,
      defaultOptions.deliverToContact.trim(),
      defaultOptions.poNumber?.trim() || '',
      defaultOptions.shippingAddressId?.toString(),
      undefined,
      defaultOptions.recipientEmail?.trim() ?? '',
      defaultOptions.recipientPhoneNumber?.trim() ?? ''
    ).then((response) => {
      setDraftOrderId(response.data.basket.checkoutStamp)
      setOrderId(response.data.createdOrders[0].orderNumber)
      setOrder(response.data.createdOrders[0])
      setAllOrders(response.data.createdOrders)
      setIsInitialized(true)
      return response.data.basket.checkoutStamp
    })
  }

  const errorOrderMessage = 'An error occurred creating your order'
  const localStorageDeliveryNoteKey = 'deliveryNote'
  const localStorageAddressKey = 'new-address'

  const initializeDeliveryOptions = useCallback(async () => {
    if (isInitialized || initializationInProgress.current) {
      dispatch(createAnnounceEvent(AnnounceMode.Error, errorOrderMessage))
      return
    }

    if (!userDetails || !defaultShippingAddress) {
      dispatch(createAnnounceEvent(AnnounceMode.Error, errorOrderMessage))
      return
    }

    try {
      initializationInProgress.current = true
      if (!basket.isLoading && basket.data?.items?.length) {
        await initOptions()
      }
    } catch (error) {
      dispatch(
        createAnnounceEvent(
          AnnounceMode.Error,
          `An error occurred creating your order. ${error}`
        )
      )
    } finally {
      initializationInProgress.current = false
    }
  }, [
    isInitialized,
    userDetails,
    defaultShippingAddress,
    portfolioCountryCode,
    basket.isLoading,
    basket?.data?.items,
    basket?.data?.state
  ])

  const saveAddressToLocalStorage = async (address: OrderAddressDto) => {
    const currentInstituteId = await getLocallyStoredInstituteId()
    const savedInstituteId = localStorage.getItem('institute_id')
    if (!savedInstituteId || savedInstituteId !== currentInstituteId) {
      localStorage.removeItem(localStorageAddressKey)
      localStorage.setItem('institute_id', currentInstituteId || '')
    }
    localStorage.setItem(localStorageAddressKey, JSON.stringify(address))
  }

  const getAddressResponseErrorMessage = (message: any) => {
    if (message) {
      const messageLine = message.split(',')
      if (messageLine && messageLine[6]) {
        const messageLineText = messageLine[6].split(':')
        if (messageLineText) {
          const errorMessage = messageLineText[2]
          if (errorMessage) {
            const errorMessageWithoutQuotations = errorMessage.split('"')
            if (errorMessageWithoutQuotations) {
              const finalErrorMessage = errorMessageWithoutQuotations[1]
              return finalErrorMessage ?? ''
            }
          }
        }

        return ''
      }
    }
  }

  const handleChangeAddress = (selectedAddressId: string) => {
    localStorage.setItem(
      'deliveryAddress',
      JSON.stringify({
        shippingAddressId: selectedAddressId
      })
    )
    setDeliveryOptions({
      ...deliveryOptions,
      shippingAddressId: selectedAddressId
    })
  }

  const handleEditClick = () => {
    // Ensure an address is selected when entering edit mode
    let addressToSelect: string | undefined

    // Check if current selection is valid and exists in deliveryAddresses
    const currentAddressExists =
      deliveryOptions.shippingAddressId &&
      deliveryAddresses?.some(
        (addr) => addr.addressId === deliveryOptions.shippingAddressId
      )

    // Priority: 1. Keep current if valid, 2. Default shipping address, 3. First available address
    if (currentAddressExists) {
      addressToSelect = deliveryOptions.shippingAddressId
    } else if (
      defaultShippingAddress?.addressId &&
      deliveryAddresses?.some(
        (addr) => addr.addressId === defaultShippingAddress.addressId
      )
    ) {
      addressToSelect = defaultShippingAddress.addressId
    } else if (deliveryAddresses && deliveryAddresses.length > 0) {
      addressToSelect = deliveryAddresses[0].addressId
    }

    // Always ensure we have an address selected
    if (addressToSelect) {
      // Update if different from current
      if (addressToSelect !== deliveryOptions.shippingAddressId) {
        handleChangeAddress(addressToSelect)
      }
    }

    setIsEditing(true)
  }

  const handlePoChange = (value: string) => {
    setDeliveryOptions({ ...deliveryOptions, poNumber: value })
  }

  const handleFormSubmit = (data: CreateShippingAddressDto) => {
    if (data && data.address) {
      setIsSubmittingAddress(true)
      const newAddress: CreateCdhShippingAddressDto = {
        address: {
          ...data.address,
          countryCode: data.address.country
        }
      }
      newUnvalidatedShippingAddress(newAddress)
        .then((response) => {
          if (response?.data) {
            const newAddress = response?.data
            if (newAddress) {
              const newDeliveryAddresses: OrderAddressDto[] =
                deliveryAddresses.slice()
              newDeliveryAddresses.unshift(newAddress)
              setDeliveryAddresses(newDeliveryAddresses)
              setDeliveryOptions({
                ...deliveryOptions,
                shippingAddressId: newAddress.addressId
              })
              saveAddressToLocalStorage(newAddress)
              handleChangeAddress(newAddress.addressId)
            }
            analyticsServiceSingleton.trackEvent(
              AnalyticsEvent.CreateDeliveryAddress,
              {}
            )
            setIsNewShippingAddressOpen(false)
            setAddressModalError('')
            setResetForm(true)

            const addressScroll = document.getElementById('scrollView')
            addressScroll?.scrollTo({
              behavior: 'smooth',
              top: 0
            })
          }
        })
        .catch((error: AxiosError) => {
          const { code, message } = error
          setResetForm(false)
          // If request is cancelled continue
          if (error.message === AuthError.RequestCancelled) {
            return
          }
          // If we have a full error show it
          if (error.response && error.response.data) {
            setAddressModalError(
              getAddressResponseErrorMessage(
                error.response.data.dependency.response
              )
            )
          } else {
            dispatch(
              createAnnounceEvent(
                AnnounceMode.Error,
                `${t(
                  'request_new_shipping_address:submitted_fail_message'
                )} ${message} ${code ?? ''}`
              )
            )
          }
        })
        .finally(() => {
          setIsSubmittingAddress(false)
        })
    }
  }

  const validateDeliveryDetails = (details: {
    recipientName: string
    recipientPhone: string
    deliveryNote?: string
  }): FieldErrors => {
    const errors: FieldErrors = {}

    // Validate name
    if (!details.recipientName || details.recipientName.trim() === '') {
      errors.nameError = getInputValidation(ValidationType.RequiredField)
    }

    // Validate phone
    if (!details.recipientPhone || details.recipientPhone.trim() === '') {
      errors.phoneError = getInputValidation(ValidationType.RequiredField)
    } else {
      // Validate phone format
      const phoneRegex = /^\+?[\d\s-()]{10,}$/
      if (!phoneRegex.test(details.recipientPhone.trim())) {
        errors.phoneError = 'Please enter a valid phone number'
      }
    }

    return errors
  }

  const handleSaveDeliveryDetails = (details: {
    recipientName: string
    recipientEmail: string
    recipientPhone: string
    deliveryNote?: string
  }) => {
    const validationErrors = validateDeliveryDetails(details)
    setFieldErrors(validationErrors)

    if (Object.keys(validationErrors).length === 0) {
      setDeliveryOptions({
        ...deliveryOptions,
        deliverToContact: details.recipientName,
        recipientEmail: details.recipientEmail,
        recipientPhoneNumber: details.recipientPhone
      })
      return true
    }
    return false
  }

  const handleSave = () => {
    const isEmailError =
      checkEmail(editForm.recipientEmail) || !editForm.recipientEmail.trim()

    if (isEmailError) {
      return
    }

    const success = handleSaveDeliveryDetails?.(editForm)
    if (success) {
      setIsEditing(false)
    }
  }

  const handleNewShippingAddress = () => setIsNewShippingAddressOpen(true)

  const updateOrderLineDescription = (orderLine: OrderLineDto) => {
    if (orderLine.itemDescription.includes('Standard Coldchain Data Logger')) {
      return t('opa_checkout:additional_lines.data_logger_cold')
    } else if (
      orderLine.itemDescription.includes('Standard Ambient Data Logger')
    ) {
      return t('opa_checkout:additional_lines.data_loger_ambient')
    }
    return orderLine.itemDescription
  }

  const handleDeliveryNote = () => {
    if (deliveryNote) {
      localStorage.setItem(localStorageDeliveryNoteKey, deliveryNote)
      analyticsServiceSingleton.trackEvent(AnalyticsEvent.AddDeliveryNote, {})
    } else {
      localStorage.setItem(localStorageDeliveryNoteKey, '')
    }
  }

  const compareAddresses = (
    address1: OrderAddressDto,
    address2: OrderAddressDto
  ): boolean => {
    return (
      address1.address1 === address2.address1 &&
      address1.city === address2.city &&
      address1.postalCode === address2.postalCode &&
      address1.state === address2.state
    )
  }

  const isSelectedAddressSameAsStored = (): boolean => {
    const savedAddressStr = localStorage.getItem(localStorageAddressKey)
    if (!savedAddressStr) return false
    try {
      const savedAddress = JSON.parse(savedAddressStr) as OrderAddressDto
      const selectedAddress = deliveryAddresses.find(
        (addr) => addr.addressId === deliveryOptions.shippingAddressId
      )

      if (!selectedAddress) return false

      return compareAddresses(selectedAddress, savedAddress)
    } catch (e) {
      console.error('Error parsing saved address:', e)
      return false
    }
  }

  /**
   * Order is actually booked at this step
   */
  const handlePlaceOrderSubmit = () => {
    if (!hasErrorMessage) {
      setViewMode(CheckoutViewMode.Submitting)
      window.scrollTo({
        behavior: 'smooth',
        top: 0
      })

      const isDefaultPoNumber = deliveryOptions.poNumber === 'PO'
      const isNewShippingAddress = isSelectedAddressSameAsStored()
      attemptOrderUpdate(isDefaultPoNumber, isNewShippingAddress, 'Y')
    }
  }

  // Attempts to update the order.
  const attemptOrderUpdate = (
    isDefaultPoNumber: boolean,
    isNewShippingAddress: boolean,
    duplicatePoCheck: string
  ) => {
    updateOrder(orderId!, orderId!, {
      bookedFlag: 'N',
      shippingHold: isNewShippingAddress ? 'Y' : 'N',
      deliverToContact: deliveryOptions.deliverToContact,
      custPONumber: isDefaultPoNumber ? orderId : deliveryOptions.poNumber,
      recipientEmail: deliveryOptions.recipientEmail,
      recipientPhoneNumber: deliveryOptions.recipientPhoneNumber,
      deliveryNote: deliveryNote,
      shipToOrgId: !isNaN(parseInt(deliveryOptions.shippingAddressId!))
        ? parseInt(deliveryOptions.shippingAddressId!)
        : null,
      duplicatePoCheck: duplicatePoCheck
    })
      .then(() => {
        handleDeliveryNote()
        return submitOrder(draftOrderId!)
      })
      .then((response) => {
        response.data.checkedOutOrders.forEach((order) =>
          analyticsServiceSingleton.trackEvent(AnalyticsEvent.OrderCompleted, {
            order: order.orderNumber,
            order_number: order.orderNumber,
            division: 'GA',
            institute_id: user?.institute?.instituteId,
            has_hold: order.holds.length > 0,
            currency: order.currencyCode,
            order_value: order.totals.total
          })
        )
        setOrderWasSubmitted(true)
        basketDispatch({
          type: ActionType.OrderSubmitted,
          completedOrder: response.data
        })
        //remove expected delivery date from basket context after submit order
        basketDispatch({
          type: ActionType.SetExpectedDeliveryDate
        })

        let basketDetails: UpdateBasketDetailsDto = defaultBasketDetails
        if (userRole && userDetails)
          basketDetails = returnDefaultBasketValues(userRole, userDetails)
        basketDispatch({
          type: ActionType.UpdateBasketDetails,
          basketDetails: basketDetails
        })

        // Trigger survey and pass through user and order numbers
        showWootricSurvey(
          user,
          response.data.checkedOutOrders.map((o) => o.orderNumber).join(','),
          'GA'
        )
      })
      .catch((error) => {
        if (error.response?.status === 400 && duplicatePoCheck === 'Y') {
          let errorMessage =
            error.response?.data?.dependency?.response || error.message

          try {
            const parsed = JSON.parse(errorMessage)
            if (parsed?.dependency?.response) {
              errorMessage = parsed.dependency.response
            }
          } catch {}

          const poMatch = errorMessage.match(/The PO Number\s*\(?([^)]+)\)?/i)
          const ordersMatch = errorMessage.match(/orders?\s*\(([^)]+)\)/i)

          if (poMatch && ordersMatch) {
            const poNumber = poMatch ? poMatch[1].trim() : null
            const orderNumbers = ordersMatch
              ? ordersMatch[1]
                  .split(',')
                  .map((id: string) => id.trim())
                  .filter(Boolean)
              : []

            setDuplicatePoData({ poNumber, orderNumbers })
            setIsDuplicatePoModalOpen(true)
            setViewMode(CheckoutViewMode.ShowOrders)
            return
          } else {
            setDuplicatePoData({
              poNumber: deliveryOptions.poNumber || '',
              orderNumbers: []
            })
            setIsDuplicatePoModalOpen(true)
            setViewMode(CheckoutViewMode.ShowOrders)
            return
          }
        }

        setViewMode(CheckoutViewMode.ShowOrders)
        const basketError = handleBasketError(error, dispatch)
        !basketError &&
          dispatch(
            createAnnounceEvent(
              AnnounceMode.Error,
              `An error occurred submitting your order. ${error}`
            )
          )
      })
  }

  // Handle duplicate PO confirmation.
  const handleDuplicatePoConfirm = () => {
    setIsProcessingDuplicatePo(true)
    setIsDuplicatePoModalOpen(false)
    setViewMode(CheckoutViewMode.Submitting)

    const isDefaultPoNumber = deliveryOptions.poNumber === 'PO'
    const isNewShippingAddress = isSelectedAddressSameAsStored()

    attemptOrderUpdate(isDefaultPoNumber, isNewShippingAddress, 'N')
  }

  // Handle duplicate PO cancel
  const handleDuplicatePoCancel = () => {
    setIsDuplicatePoModalOpen(false)
    setDuplicatePoData(null)
    setIsProcessingDuplicatePo(false)
    setViewMode(CheckoutViewMode.ShowOrders)
  }

  const handleDuplicatePoCancelClick = () => {
    setAgreedTandCs(false)
    if (handleDuplicatePoCancel) {
      handleDuplicatePoCancel()
    }
  }

  const handleOrderSubmitDebounced = debounce(handlePlaceOrderSubmit, 500)

  // Calculate total from all orders
  const calculateTotalFromAllOrders = (): number => {
    if (!allOrders || allOrders.length === 0) {
      return order?.totals.total ?? 0
    }

    return allOrders.reduce(
      (sum, currentOrder) => sum + (currentOrder.totals.total ?? 0),
      0
    )
  }

  // Calculate total tax from all orders
  const calculateTotalTaxFromAllOrders = (): number => {
    if (!allOrders || allOrders.length === 0) {
      // Ensure we return a number even if order?.totals.tax is undefined
      return typeof order?.totals.tax === 'number' ? order.totals.tax : 0
    }

    return allOrders.reduce((sum, currentOrder) => {
      // Ensure we only add numbers
      const tax =
        typeof currentOrder.totals.tax === 'number'
          ? currentOrder.totals.tax
          : 0
      return sum + tax
    }, 0)
  }

  // Check if tax is available for display
  const isTaxAvailable = (): boolean => {
    if (!allOrders || allOrders.length === 0) {
      return typeof order?.totals.tax === 'number'
    }

    // Check if all orders have valid tax values
    return allOrders.every(
      (currentOrder) => typeof currentOrder.totals.tax === 'number'
    )
  }

  // Check if the order line is a data logger
  const isDataLogger = (orderLine: OrderLineDto): boolean => {
    return orderLine.itemDescription.includes(
      'Data Logger for 2 C to 8 C - Standard Coldchain Data Logger'
    )
  }

  // Get all data logger charges from all orders
  const getDataLoggerCharges = (): OrderLineDto[] => {
    const dataLoggerLines: OrderLineDto[] = []

    // Check primary order
    if (order) {
      order.lines
        .filter((line) => isDataLogger(line))
        .forEach((line) => dataLoggerLines.push(line))
    }

    // Check additional orders
    if (allOrders && allOrders.length > 1) {
      allOrders.slice(1).forEach((additionalOrder) => {
        additionalOrder.lines
          .filter((line) => isDataLogger(line))
          .forEach((line) => dataLoggerLines.push(line))
      })
    }

    return dataLoggerLines
  }

  const handleSafetyLetterDownloadSelect = (agreed: boolean) => {
    setHasDownloadedSafetyLetter(agreed)
  }

  const handleDownloadSafetyLetter = () => {
    // Find safety letter from documents
    const safetyLetterDocs: ItemDocumentDto[] = []
    const hasSafetyLetter = (fileName: string): boolean => {
      return (
        fileName.toLowerCase().includes('mhra saftey letter') ||
        fileName.toLowerCase().includes('mhra safety letter')
      )
    }
    basket?.data?.items.forEach((item) =>
      item.skuCatalogItem.documents.forEach(
        (d) =>
          d.documentType &&
          hasSafetyLetter(d.documentType) &&
          safetyLetterDocs.push(d)
      )
    )
    // Download all of them
    if (safetyLetterDocs && safetyLetterDocs.length > 0) {
      safetyLetterDocs.forEach(
        (documentItem) =>
          documentItem.generatedId &&
          downloadDocumentById(documentItem.generatedId)
            .then((response) => {
              documentItem.documentType &&
                documentItem.documentUrl &&
                download(
                  response.data,
                  getFilenameFromUrl(documentItem.documentUrl),
                  documentItem.documentType
                )
              analyticsServiceSingleton.trackEvent(
                AnalyticsEvent.DocumentDownload,
                {
                  ...documentItem
                }
              )
            })
            .catch((error: AxiosError) => {
              window.scrollTo(0, 0)
              dispatch(
                createAnnounceEvent(
                  AnnounceMode.Error,
                  `There was an error downloading your document. ${error}`
                )
              )
            })
      )
    }
  }

  /**
   * When addresses are loaded set them and select the default shipping address
   */
  const isOptionsLoaded = useRef(false) // Make sure this only happens once

  useEffect(() => {
    if (
      !isOptionsLoaded.current &&
      !institute.isLoading &&
      institute?.data &&
      defaultShippingAddress
    ) {
      const addresses = institute.data.shipTo.map((address) => address)
      const savedAddress = localStorage.getItem(localStorageAddressKey)

      if (savedAddress) {
        try {
          const parsedAddress = JSON.parse(savedAddress)
          const addressExists = addresses.some(
            (addr) =>
              addr.address1 === parsedAddress.address1 &&
              addr.city === parsedAddress.city &&
              addr.state === parsedAddress.state &&
              addr.postalCode === parsedAddress.postalCode
          )

          if (!addressExists) {
            addresses.unshift(parsedAddress)
          }
        } catch (e) {
          console.error('Error parsing saved address:', e)
        }
      }

      setDeliveryAddresses(addresses)
      setDeliveryOptions({
        ...deliveryOptions,
        shippingAddressId: savedAddress
          ? JSON.parse(savedAddress).addressId
          : defaultShippingAddress.addressId
      })

      isOptionsLoaded.current = true
    }
  }, [institute, defaultShippingAddress])

  useEffect(() => {
    if (!isInitialized && !initializationInProgress.current) {
      initializeDeliveryOptions()
    }
  }, [isInitialized, initializeDeliveryOptions])

  useEffect(() => {
    if (
      completedOrder &&
      orderWasSubmitted &&
      viewBasket?.state === BasketStatus.Submitted.toString()
    ) {
      // Get the new basket
      getBasketAsync(basketDispatch).then(() => {
        // Empty basket and refresh
        // This is commented releted to ticket clos-2075
        // basketDispatch({
        //   type: ActionType.EmptyBasket
        // })

        isNewCheckoutPage
          ? history.push(`/order/${orderId}`, {
              from: window.location.pathname,
              displayAnnounceOrderSuccess: true
            })
          : history.push(`/checkout/summary`)
      })
    }
  }, [basketDispatch, history, orderWasSubmitted, viewBasket, completedOrder])

  useEffect(() => {
    if (orders && orders.length > 0 && !orderWasSubmitted) {
      setViewMode(CheckoutViewMode.ShowOrders)
    }
  }, [orderWasSubmitted, orders])

  useEffect(() => {
    if (
      !basket.isLoading &&
      basket?.data?.items?.length === 0 &&
      countries?.length !== 0 &&
      !completedOrder &&
      !orderWasSubmitted &&
      viewBasket?.state !== BasketStatus.Submitted.toString()
    ) {
      history.push('/basket')
      return
    } else {
      setViewMode(CheckoutViewMode.ShowOrders)
    }
  }, [basket.isLoading, basket?.data?.items?.length, history, countries])

  // If we navigate away remove orders - no way of knowing what
  useEffect(
    () => () => {
      cancelDraftOrder()
        .then(() => {
          console.warn('Cancelled order')
        })
        .catch((error) =>
          console.warn(`Attempt to cancel order failed: ${error}`)
        )
    },
    []
  )
  useEffect(() => {
    if (institute?.data?.instituteId) {
      const storedInstituteId = localStorage.getItem('institute_id')
      if (
        storedInstituteId &&
        storedInstituteId !== institute.data.instituteId.toString()
      ) {
        localStorage.removeItem(localStorageAddressKey)
        localStorage.setItem(
          'institute_id',
          institute.data.instituteId.toString()
        )
      }
    }
  }, [institute?.data?.instituteId])

  // Initial basket load
  useEffect(() => {
    refreshBasketData()
  }, [refreshBasketData])

  useEffect(() => {
    setEditForm({
      recipientName: deliveryOptions.deliverToContact || '',
      recipientEmail: deliveryOptions.recipientEmail || '',
      recipientPhone: deliveryOptions.recipientPhoneNumber || '',
      deliveryNote: deliveryNote || ''
    })
  }, [deliveryOptions, deliveryNote])

  useEffect(() => {
    setPoNumber(duplicatePoData?.poNumber || '')
  }, [duplicatePoData])

  return (
    <>
      <StyledCheckoutDrawer>
        {isRefreshingBasket ||
        viewMode === CheckoutViewMode.Loading ||
        isInitialLoad ||
        !isInitialized ? (
          <StyledSpinnerContainer>
            <ClinText
              as={'div'}
              display={'block'}
              fontWeight={ClinTheme.fontWeights.medium}
              fontSize={ClinTheme.fontSizes[3]}
              color={ClinTheme.colors.black}
              lineHeight={ClinTheme.lineHeights.heading[1]}
            >
              {t('checkout:loading_checkout')}
            </ClinText>
            <ClinSpinner size={ClinTheme.space[4]} />
          </StyledSpinnerContainer>
        ) : (
          <>
            {viewMode === CheckoutViewMode.Submitting && (
              <StyledSpinnerContainer>
                <ClinText
                  as={'div'}
                  display={'block'}
                  fontWeight={ClinTheme.fontWeights.medium}
                  fontSize={ClinTheme.fontSizes[3]}
                  color={ClinTheme.colors.black}
                  lineHeight={ClinTheme.lineHeights.heading[1]}
                >
                  {t('checkout:placing_your_order')}
                </ClinText>
                <ClinSpinner size={ClinTheme.space[4]} />
              </StyledSpinnerContainer>
            )}

            {viewMode === CheckoutViewMode.ShowOrders && (
              <>
                <StyledDrawerHeader>
                  <ClinGroup justifyContent={'space-between'}>
                    <ClinText
                      as={'div'}
                      fontWeight={ClinTheme.fontWeights.medium}
                      fontSize={ClinTheme.fontSizes[3]}
                      color={ClinTheme.colors.black}
                      lineHeight={ClinTheme.lineHeights.heading[1]}
                    >
                      {t('checkout:title')}
                    </ClinText>
                  </ClinGroup>
                </StyledDrawerHeader>
                <StyledDrawerBody>
                  {/* Duplicate PO Information Block */}
                  {isDuplicatePoModalOpen && duplicatePoData && (
                    <ClinAnnounceBar
                      marginBottom={ClinTheme.space[2]}
                      marginTop={0}
                      iconSize={26}
                      title={t('checkout:po_number_title')}
                      mode={AnnounceMode.Information}
                    >
                      <StyledAnnounceBarContainer>
                        <ClinText
                          color={ClinTheme.colors.black}
                          lineHeight={ClinTheme.lineHeights.heading[1]}
                        >
                          {duplicatePoData.orderNumbers &&
                          duplicatePoData.orderNumbers.length > 0 ? (
                            <Trans
                              i18nKey="checkout:po_number_warning"
                              components={{
                                bold: <strong />
                              }}
                              values={{
                                poNumber: duplicatePoData.poNumber,
                                order: duplicatePoData.orderNumbers.join(', ')
                              }}
                            >
                              <></>
                            </Trans>
                          ) : (
                            <>
                              The PO Number{' '}
                              <strong>{duplicatePoData.poNumber}</strong> is
                              already present against an existing order. Would
                              you like to proceed with this PO number?
                            </>
                          )}
                        </ClinText>
                        <StyledButtonSection2>
                          <ClinButton
                            style={{ height: '24px', padding: '12px' }}
                            variant="primary"
                            onClick={handleDuplicatePoConfirm}
                            disabled={isProcessingDuplicatePo}
                          >
                            {isProcessingDuplicatePo
                              ? t('common:buttons.processing')
                              : t('common:buttons.yes')}
                          </ClinButton>
                          <ClinButton
                            style={{ height: '24px', padding: '12px' }}
                            variant="primary"
                            onClick={handleDuplicatePoCancelClick}
                            disabled={isProcessingDuplicatePo}
                          >
                            {t('common:buttons.no')}
                          </ClinButton>
                        </StyledButtonSection2>
                      </StyledAnnounceBarContainer>
                    </ClinAnnounceBar>
                  )}
                  <StyledEstimatedDeliveryDate>
                    <ClinIcon
                      iconName={ClinIconPathName.OrderBox}
                      iconSize={ClinTheme.space[6]}
                      iconFill={ClinTheme.colors.primaryMid}
                    />
                    <StyledEstimatedDeliveryText>
                      <ClinText
                        as="div"
                        color={ClinTheme.colors.primaryMid}
                        fontWeight={ClinTheme.fontWeights.medium}
                        lineHeight={ClinTheme.lineHeights.heading[0]}
                      >
                        {t('checkout:order_by')}
                      </ClinText>
                    </StyledEstimatedDeliveryText>
                  </StyledEstimatedDeliveryDate>

                  <StyledNewCheckoutBlock>
                    <StyledNewCheckoutBlockHeader>
                      <ClinText
                        as="h3"
                        color={ClinTheme.colors.black}
                        lineHeight={ClinTheme.lineHeights.largeParagraph}
                        fontSize={ClinTheme.fontSizes[3]}
                        fontWeight={ClinTheme.fontWeights.medium}
                      >
                        {t('checkout_options:section_title_2')}
                      </ClinText>
                      {!isEditing && (
                        <StyledClinButtonEdit onClick={handleEditClick}>
                          <StyledIcon width={24} height={24} src={EditIcon} />
                        </StyledClinButtonEdit>
                      )}
                    </StyledNewCheckoutBlockHeader>
                    <StyledNewCheckoutUserInfoBlock>
                      {!isEditing && (
                        <>
                          {editForm.recipientName && (
                            <StyledRow>
                              <ClinText
                                lineHeight="24px"
                                fontSize={ClinTheme.fontSizes[1]}
                                fontWeight={ClinTheme.fontWeights.medium}
                              >
                                {t('checkout:label_name')}:
                              </ClinText>
                              <ClinText
                                lineHeight="24px"
                                fontSize={ClinTheme.fontSizes[1]}
                              >
                                {editForm.recipientName}
                              </ClinText>
                            </StyledRow>
                          )}
                          {editForm.recipientEmail && (
                            <StyledRow>
                              <ClinText
                                lineHeight="24px"
                                fontSize={ClinTheme.fontSizes[1]}
                                fontWeight={ClinTheme.fontWeights.medium}
                              >
                                {t('checkout:label_email')}:
                              </ClinText>
                              <ClinText
                                lineHeight="24px"
                                fontSize={ClinTheme.fontSizes[1]}
                              >
                                {editForm.recipientEmail}
                              </ClinText>
                            </StyledRow>
                          )}
                          {editForm.recipientPhone && (
                            <StyledRow>
                              <ClinText
                                lineHeight="24px"
                                fontSize={ClinTheme.fontSizes[1]}
                                fontWeight={ClinTheme.fontWeights.medium}
                              >
                                {t('checkout:label_tel')}:
                              </ClinText>
                              <ClinText
                                lineHeight="24px"
                                fontSize={ClinTheme.fontSizes[1]}
                              >
                                {editForm.recipientPhone.trim()}
                              </ClinText>
                            </StyledRow>
                          )}
                          {(() => {
                            const selectedAddress = deliveryAddresses?.find(
                              (addr) => addr.addressId === selectedAddressId
                            )
                            return (
                              selectedAddress && (
                                <>
                                  <ClinText
                                    lineHeight="24px"
                                    fontSize={ClinTheme.fontSizes[1]}
                                    fontWeight={ClinTheme.fontWeights.medium}
                                    marginTop={ClinTheme.space[2]}
                                  >
                                    {t('checkout:label_address')}:
                                  </ClinText>
                                  <DeliveryAddress
                                    fontWeight={ClinTheme.fontWeights.normal}
                                    fontSize={ClinTheme.fontSizes[1]}
                                    address={selectedAddress}
                                    isCompact={true}
                                  />
                                </>
                              )
                            )
                          })()}
                        </>
                      )}
                    </StyledNewCheckoutUserInfoBlock>
                    {isEditing && (
                      <StyledNewCheckoutBlockBody>
                        <StyledRow>
                          <StyledColumn>
                            <ClinTextInput
                              width={'100%'}
                              labelFontWeight={ClinTheme.fontWeights.normal}
                              hasError={!!fieldErrors.nameError}
                              prompt={fieldErrors.nameError ?? ''}
                              id="recipients-name"
                              name="recipientsName"
                              label={t(
                                'checkout_options:checkout_options.delivery_contact'
                              )}
                              value={editForm.recipientName}
                              onChange={(e) =>
                                setEditForm({
                                  ...editForm,
                                  recipientName: e.currentTarget.value
                                })
                              }
                              required
                            />
                          </StyledColumn>
                        </StyledRow>
                        <StyledRow>
                          <StyledColumn>
                            <ClinSpacer height={ClinTheme.space[3]} />
                            <ClinTextInput
                              labelFontWeight={ClinTheme.fontWeights.normal}
                              type="email"
                              width="100%"
                              id="recipients-email"
                              name="recipientsEmail"
                              label={t(
                                'checkout_options:delivery_contact_email'
                              )}
                              value={editForm.recipientEmail}
                              hasError={!!emailErrorMessage}
                              prompt={emailErrorMessage ?? ''}
                              onChange={(e) =>
                                setEditForm({
                                  ...editForm,
                                  recipientEmail: e.currentTarget.value
                                })
                              }
                              required
                            />
                          </StyledColumn>
                        </StyledRow>
                        <StyledRow>
                          <StyledColumn>
                            <ClinSpacer height={ClinTheme.space[3]} />
                            <ClinTextInput
                              labelFontWeight={ClinTheme.fontWeights.normal}
                              isPhone={true}
                              width="100%"
                              id="recipients-phone"
                              name="recipientsPhone"
                              label={t(
                                'checkout_options:delivery_contact_phone'
                              )}
                              hasError={!!fieldErrors.phoneError}
                              prompt={fieldErrors.phoneError ?? ''}
                              value={editForm.recipientPhone}
                              required={true}
                              onPhoneChange={(formattedValue) =>
                                setEditForm({
                                  ...editForm,
                                  recipientPhone: formattedValue
                                })
                              }
                            />
                            <ClinText
                              marginTop={ClinTheme.space[2]}
                              fontSize={ClinTheme.fontSizes[0]}
                              lineHeight={ClinTheme.lineHeights.small}
                              fontWeight={ClinTheme.fontWeights.normal}
                            >
                              {t('checkout:area_code')}
                            </ClinText>
                          </StyledColumn>
                        </StyledRow>
                        <ClinSpacer height={ClinTheme.space[5]} />
                        <Row>
                          <Col xs={12} sm={12}>
                            <>
                              <ClinText
                                as="h5"
                                fontSize={ClinTheme.fontSizes[1]}
                                marginBottom={ClinTheme.space[2]}
                                marginTop={'0px'}
                              >
                                {t(
                                  'checkout_options:checkout_options.address_select_title'
                                )}
                              </ClinText>
                              <StyledDeliveryAddressCheckoutWrapper
                                id="scrollView"
                                className="deliveryAddressWrapper"
                              >
                                {deliveryAddresses?.map((address, index) => (
                                  <div key={address.addressId}>
                                    <StyledClinRadio
                                      label={`${address.addressId}-index`}
                                      id={`${address.addressId}-index`}
                                      checked={
                                        address.addressId === selectedAddressId
                                      }
                                      isLast={
                                        index === deliveryAddresses.length - 1
                                      }
                                      isCompact={true}
                                      onClick={() =>
                                        handleChangeAddress &&
                                        handleChangeAddress(address.addressId)
                                      }
                                    >
                                      <Row>
                                        <Col>
                                          <DeliveryAddress
                                            address={address}
                                            isCompact={true}
                                          />
                                        </Col>
                                      </Row>
                                    </StyledClinRadio>
                                  </div>
                                ))}
                              </StyledDeliveryAddressCheckoutWrapper>
                            </>
                          </Col>
                        </Row>
                        <StyledDeliveryAddressWrap id="scrollView">
                          <StyledDeliveryAddressNewCheckout as="div">
                            <ClinText
                              as="h5"
                              variant={TypographyVariant.LargeParagraph}
                            >
                              {t(
                                'checkout_options:do_not_see_delivery_options'
                              )}
                            </ClinText>
                          </StyledDeliveryAddressNewCheckout>
                          <StyledNewShippingAddressLinkOneStepCheckout
                            style={{ margin: 0 }}
                            onClick={() =>
                              handleNewShippingAddress &&
                              handleNewShippingAddress()
                            }
                          >
                            {t(
                              'checkout_options:checkout_options.new_shipping_address_btn'
                            )}
                          </StyledNewShippingAddressLinkOneStepCheckout>
                        </StyledDeliveryAddressWrap>
                      </StyledNewCheckoutBlockBody>
                    )}
                    {!isEditing && (
                      <StyledNewCheckoutAdditionalBlock>
                        <Row>
                          <Col xs={12} sm={12}>
                            <ClinCheckbox
                              marginRight="16px"
                              labelFontSize={ClinTheme.fontSizes[1]}
                              id="checkbox-id"
                              label={t('checkout:add_delivery_note')}
                              checked={showDeliveryNotes}
                              onChange={(e) =>
                                setShowDeliveryNotes(e.target.checked)
                              }
                            />
                            {showDeliveryNotes && (
                              <>
                                <StyledCheckoutTextareaContainer>
                                  <ClinSpacer height={ClinTheme.space[3]} />
                                  <ClinTextarea
                                    labelFontSize={ClinTheme.fontSizes[0]}
                                    id="textarea-id"
                                    name="textarea-name"
                                    label={t('checkout:delivery_note_label')}
                                    placeholder={t(
                                      'checkout:delivery_note_text_area'
                                    )}
                                    value={deliveryNote}
                                    onChange={(e) =>
                                      setDeliveryNote(e.target.value)
                                    }
                                  />
                                </StyledCheckoutTextareaContainer>
                                <ClinText
                                  fontSize={ClinTheme.fontSizes[0]}
                                  marginTop={ClinTheme.space[2]}
                                  letterSpacing={0}
                                >
                                  {t('checkout:delivery_note_help_text')}
                                </ClinText>
                              </>
                            )}
                          </Col>
                        </Row>
                        {!isEditing && estimatedDeliveryDate && (
                          <StyledCheckoutDeliveryDateContainer>
                            <StyledCheckoutDeliveryDateIconContainer>
                              <ClinIcon
                                viewBox="0 0 37 35"
                                iconHeight={'32px'}
                                iconSize={'32px'}
                                iconName={ClinIconPathName.DeliveryBox}
                                iconFill={ClinTheme.colors.primary}
                              />
                            </StyledCheckoutDeliveryDateIconContainer>
                            <StyledCheckoutDeliveryDateContent>
                              <ClinText
                                fontSize={ClinTheme.fontSizes[0]}
                                lineHeight={ClinTheme.lineHeights.small}
                                fontWeight={ClinTheme.fontWeights.medium}
                              >
                                {t('checkout:estimated_delivery_label')}
                              </ClinText>
                              <ClinText
                                fontSize={ClinTheme.fontSizes[1]}
                                fontWeight={ClinTheme.fontWeights.medium}
                                lineHeight={ClinTheme.lineHeights.body}
                                color={ClinTheme.colors.primaryMid}
                              >
                                {DateTime.fromISO(estimatedDeliveryDate, {
                                  zone: 'utc'
                                })
                                  .setLocale(i18n.language)
                                  .toFormat('cccc, MMMM d')}
                              </ClinText>
                              <ClinText
                                fontSize={ClinTheme.fontSizes[0]}
                                fontWeight={ClinTheme.fontWeights.normal}
                                lineHeight="16px"
                              >
                                {t('checkout:delivery_estimates')}
                              </ClinText>
                            </StyledCheckoutDeliveryDateContent>
                          </StyledCheckoutDeliveryDateContainer>
                        )}
                      </StyledNewCheckoutAdditionalBlock>
                    )}
                    {isEditing && (
                      <>
                        <StyledButtonSection>
                          <StyledClinButtonPrimary
                            variant="primary"
                            style={{
                              width: '100%'
                            }}
                            onClick={handleSave}
                          >
                            {t('common:buttons.save_changes')}
                          </StyledClinButtonPrimary>
                          <StyledClinButton
                            variant="secondary"
                            style={{
                              width: '100%',
                              display: 'inline-block'
                            }}
                            onClick={() => {
                              setIsEditing(false)
                              setEditForm({
                                ...editForm,
                                recipientName:
                                  deliveryOptions.deliverToContact || '',
                                recipientEmail:
                                  deliveryOptions.recipientEmail || '',
                                recipientPhone:
                                  deliveryOptions.recipientPhoneNumber || '',
                                deliveryNote: deliveryNote || ''
                              })
                            }}
                          >
                            {t('common:buttons.cancel')}
                          </StyledClinButton>
                        </StyledButtonSection>
                        <ClinSpacer height={ClinTheme.space[3]} />
                      </>
                    )}
                    <StyledCheckoutPoBlock>
                      <StyledRow>
                        <StyledColumn>
                          <ClinTextInput
                            labelFontSize={ClinTheme.fontSizes[3]}
                            labelLineHeight={ClinTheme.lineHeights.body}
                            labelFontWeight={ClinTheme.fontWeights.medium}
                            width="100%"
                            id="po-number"
                            name="poNumber"
                            label={t('checkout_options:section_title_3')}
                            required={true}
                            hasError={!!hasErrorMessage}
                            prompt={hasErrorMessage ?? ''}
                            value={poNumber}
                            onChange={(
                              event: ChangeEvent<HTMLInputElement>
                            ) => {
                              const newValue = event.currentTarget.value
                              setPoNumber(newValue)
                              handlePoChange && handlePoChange(newValue)
                            }}
                          />
                        </StyledColumn>
                      </StyledRow>
                    </StyledCheckoutPoBlock>
                  </StyledNewCheckoutBlock>

                  <ClinSpacer height={ClinTheme.space[4]} />

                  <StyledSummaryOneStepCheckout>
                    <StyledSummaryTitle>
                      <ClinText
                        as="span"
                        variant={TypographyVariant.LargerParagraph}
                        fontWeight={ClinTheme.fontWeights.medium}
                        lineHeight={`${ClinTheme.space[4]}px`}
                      >
                        {t('basket:summary')}
                      </ClinText>
                    </StyledSummaryTitle>
                    <ClinSpacer height={16} />
                    <StyledTableContainer>
                      <TableHeader>
                        <QuantityCell style={{ paddingLeft: 0 }}>
                          <ClinText
                            variant={TypographyVariant.SmallUI}
                            lineHeight={`${ClinTheme.space[3]}px`}
                          >
                            {t('basket:quantity')}
                          </ClinText>
                        </QuantityCell>
                        <SkuCell>
                          <ClinText
                            variant={TypographyVariant.SmallUI}
                            lineHeight={`${ClinTheme.space[3]}px`}
                          >
                            {t('basket:sku')}
                          </ClinText>
                        </SkuCell>
                        <SubtotalCell style={{ paddingRight: 0 }}>
                          <ClinText
                            variant={TypographyVariant.SmallUI}
                            lineHeight={`${ClinTheme.space[3]}px`}
                            textAlign="right"
                          >
                            {t('basket:subtotal')}
                          </ClinText>
                        </SubtotalCell>
                      </TableHeader>

                      {viewBasket?.items.map((item) => (
                        <TableRow key={item.basketItemId}>
                          <QuantityCell style={{ paddingLeft: 0 }}>
                            <ClinText
                              variant={TypographyVariant.Paragraph}
                              lineHeight={`${ClinTheme.space[4]}px`}
                            >
                              {item.quantity}
                              {'x'}
                            </ClinText>
                          </QuantityCell>
                          <SkuCell>
                            <ClinText
                              variant={TypographyVariant.Paragraph}
                              lineHeight={`${ClinTheme.space[4]}px`}
                            >
                              {item.skuCatalogItem?.genericDosageConcatenation}
                            </ClinText>
                          </SkuCell>
                          <SubtotalCell style={{ paddingRight: 0 }}>
                            <ClinText
                              textAlign="right"
                              as={'h5'}
                              lineHeight={`${ClinTheme.space[3]}px`}
                              fontWeight={ClinTheme.fontWeights.medium}
                              variant={TypographyVariant.Paragraph}
                            >
                              {!item.amount
                                ? '--'
                                : numberToCurrencyString(
                                    item.amount,
                                    getBrowserLocale(),
                                    {
                                      style: 'currency',
                                      currency:
                                        item?.priceAndAvailability
                                          ?.currencyCode,
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  )}
                            </ClinText>
                          </SubtotalCell>
                        </TableRow>
                      ))}
                    </StyledTableContainer>

                    <ClinSpacer hasBorder={true} height={16} />

                    {/* Display regular order lines */}
                    {order?.lines
                      .filter(
                        (o) => o.medicationFlag !== 'Y' && !isDataLogger(o)
                      )
                      .map((orderLine: OrderLineDto, index: number) => (
                        <Fragment
                          key={`order-summary-${order.orderNumber}-${index}`}
                        >
                          <ClinGroup
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <StyledSummaryItemWrap>
                              <ClinText
                                variant={TypographyVariant.Paragraph}
                                lineHeight={`${ClinTheme.space[3]}px`}
                                marginTop={'0px'}
                                marginBottom={'0px'}
                              >
                                {updateOrderLineDescription(orderLine)}
                              </ClinText>
                            </StyledSummaryItemWrap>

                            <ClinText
                              as={'h5'}
                              variant={TypographyVariant.Paragraph}
                              lineHeight={`${ClinTheme.space[3]}px`}
                              fontWeight={ClinTheme.fontWeights.medium}
                            >
                              {numberToCurrencyString(
                                orderLine.unitSellingPrice,
                                getBrowserLocale(),
                                {
                                  style: 'currency',
                                  currency: order?.currencyCode,
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }
                              )}
                            </ClinText>
                          </ClinGroup>
                          <ClinSpacer height={16} />
                        </Fragment>
                      ))}

                    {/* Display data logger charges from all orders */}
                    {getDataLoggerCharges().map((dataLoggerLine, index) => (
                      <Fragment key={`data-logger-${index}`}>
                        <ClinGroup
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <StyledSummaryItemWrap>
                            <ClinText
                              variant={TypographyVariant.Paragraph}
                              lineHeight={`${ClinTheme.space[3]}px`}
                              marginTop={'0px'}
                              marginBottom={'0px'}
                              fontWeight={ClinTheme.fontWeights.normal}
                            >
                              Cold Chain Temp Tracker
                            </ClinText>
                          </StyledSummaryItemWrap>

                          <ClinText
                            as={'h5'}
                            variant={TypographyVariant.Paragraph}
                            lineHeight={`${ClinTheme.space[3]}px`}
                            fontWeight={ClinTheme.fontWeights.medium}
                          >
                            {numberToCurrencyString(
                              dataLoggerLine.totals.subTotal,
                              getBrowserLocale(),
                              {
                                style: 'currency',
                                currency: order?.currencyCode,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            )}
                          </ClinText>
                        </ClinGroup>
                        <ClinSpacer height={16} />
                      </Fragment>
                    ))}

                    <ClinSpacer height={8} />

                    <ClinGroup
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <StyledSummaryItemWrap>
                        <ClinText
                          variant={TypographyVariant.Paragraph}
                          lineHeight={`${ClinTheme.space[3]}px`}
                          marginTop={'0px'}
                          marginBottom={'0px'}
                        >
                          {t('ma_order_detail:tax')}
                        </ClinText>
                      </StyledSummaryItemWrap>

                      <ClinText
                        as={'h5'}
                        variant={TypographyVariant.Paragraph}
                        lineHeight={`${ClinTheme.space[3]}px`}
                        fontWeight={ClinTheme.fontWeights.medium}
                      >
                        {!isTaxAvailable()
                          ? '--'
                          : numberToCurrencyString(
                              calculateTotalTaxFromAllOrders(),
                              getBrowserLocale(),
                              {
                                style: 'currency',
                                currency: viewBasket?.currencyCode,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            )}
                      </ClinText>
                    </ClinGroup>

                    <ClinSpacer height={16} />

                    <ClinGroup justifyContent="space-between">
                      <div>
                        <ClinText
                          variant={TypographyVariant.LargerParagraph}
                          lineHeight={`${ClinTheme.space[4]}px`}
                          fontWeight={ClinTheme.fontWeights.medium}
                        >
                          {t('checkout_options:checkout_options.total')}
                        </ClinText>
                      </div>

                      <ClinText
                        as={'h5'}
                        variant={TypographyVariant.H4}
                        lineHeight={`${ClinTheme.space[5]}px`}
                        fontWeight={ClinTheme.fontWeights.medium}
                        color={ClinTheme.colors.black}
                      >
                        {!viewBasket?.total
                          ? '--'
                          : numberToCurrencyString(
                              calculateTotalFromAllOrders(),
                              getBrowserLocale(),
                              {
                                style: 'currency',
                                currency: viewBasket?.currencyCode,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            )}
                      </ClinText>
                    </ClinGroup>

                    {/* Safety Letter */}
                    {holdInformation?.hasSafetyLetterHold && (
                      <StyledSafetyCheckoutBlockBody>
                        <ClinGroup
                          alignItems="flex-start"
                          justifyContent="space-between"
                        >
                          <ClinCheckbox
                            id="safety-letter"
                            marginRight="0px"
                            checked={hasDownloadedSafetyLetter}
                            onClick={(
                              event: React.MouseEvent<HTMLInputElement>
                            ) =>
                              handleSafetyLetterDownloadSelect(
                                event.currentTarget.checked
                              )
                            }
                          />
                          <ClinText fontSize={ClinTheme.fontSizes[0]}>
                            <Trans
                              i18nKey={'checkout:checkbox_safety_label_drawer'}
                              components={{
                                embedLink: (
                                  <StyledClinButtonLink
                                    variant={'linkButton' as any}
                                    onClick={handleDownloadSafetyLetter}
                                  />
                                )
                              }}
                              shouldUnescape={true}
                            ></Trans>
                          </ClinText>
                        </ClinGroup>
                      </StyledSafetyCheckoutBlockBody>
                    )}

                    <StyledDeclarationCheckoutBlockBody>
                      <ClinGroup
                        alignItems="flex-start"
                        justifyContent="space-between"
                      >
                        <ClinCheckbox
                          marginRight={'0px'}
                          onClick={(
                            event: React.MouseEvent<HTMLInputElement>
                          ) => setAgreedTandCs(event.currentTarget.checked)}
                          id="supply-declaration"
                        />
                        {isIE ? (
                          <ClinText fontSize={ClinTheme.fontSizes[0]}>
                            <span>
                              {t('basket:declaration.confirmation_text_ie_1')}
                            </span>
                            <ul style={{ paddingLeft: '25px' }}>
                              <li>
                                {t('basket:declaration.confirmation_text_ie_2')}
                              </li>
                              <li>
                                {t('basket:declaration.confirmation_text_ie_3')}
                              </li>
                              <li>
                                {t('basket:declaration.confirmation_text_ie_4')}
                              </li>
                            </ul>
                            <span>
                              {t('basket:declaration.confirmation_text_ie_5')}
                            </span>
                          </ClinText>
                        ) : (
                          <ClinText fontSize={ClinTheme.fontSizes[0]}>
                            <Trans
                              i18nKey={summaryText}
                              components={{
                                embedLink: (
                                  <a
                                    target="_blank"
                                    href={unlicensedMedicinalProductsGuidance}
                                    rel="noreferrer"
                                    style={{
                                      color: ClinTheme.colors.vibrantBlue
                                    }}
                                  >
                                    <></>
                                  </a>
                                )
                              }}
                              shouldUnescape={true}
                            ></Trans>
                          </ClinText>
                        )}
                      </ClinGroup>
                      {!isUK && !isIE && (
                        <ClinText
                          fontSize={ClinTheme.fontSizes[0]}
                          marginTop={ClinTheme.space[3]}
                          marginLeft={'42px'}
                        >
                          {t('basket:declaration.confirmation_text_2')}
                        </ClinText>
                      )}
                    </StyledDeclarationCheckoutBlockBody>
                    <ClinButton
                      fontSize={ClinTheme.fontSizes[2]}
                      variant="primary"
                      onClick={() => handleOrderSubmitDebounced()}
                      disabled={
                        holdInformation?.hasSafetyLetterHold
                          ? !agreedTandCs ||
                            !hasDownloadedSafetyLetter ||
                            isDuplicatePoModalOpen
                          : !agreedTandCs || isDuplicatePoModalOpen
                      }
                    >
                      {t('checkout_options:checkout_options.place_order_btn')}
                    </ClinButton>
                  </StyledSummaryOneStepCheckout>

                  <ClinSpacer height={ClinTheme.space[3]} />

                  <StyledClinButton
                    display={'block'}
                    variant={'secondary'}
                    onClick={handleClose}
                  >
                    {t('common:buttons.cancel')}
                  </StyledClinButton>
                </StyledDrawerBody>
              </>
            )}
          </>
        )}
      </StyledCheckoutDrawer>
      <ClinDrawer
        open={isNewShippingAddressOpen}
        width={512}
        onClose={() => setIsNewShippingAddressOpen(false)}
      >
        <ShippingAddressDrawer
          isSubmitting={isSubmittingAddress}
          resetOnSubmit={resetForm}
          countries={countries}
          selectedCountry={portfolioCountryCode}
          errorMessage={addressModalError}
          handleFormSubmit={handleFormSubmit}
          handleClose={() => setIsNewShippingAddressOpen(false)}
        />
      </ClinDrawer>
    </>
  )
}
